import { getPreferenceTable } from '@/appLogic/initializers/preferenceTable';

// TODO: 初期化が完了してからしかpreferenceTableにアクセスしないようにしたい。

/**
 *
 * @param ownerName
 * @param kind
 * @param config
 */
const putPreference = async (ownerName: string, kind: string, config: any) => {
  const table = await getPreferenceTable();
  return await table.put({ ownerName, kind, config });
};

/**
 *
 * @param ownerName
 * @param kind
 */
const getPreference = async (ownerName: string, kind: string): Promise<any> => {
  const table = await getPreferenceTable();
  const allData = await table.getByTime(ownerName);
  const res: any[] = allData.filter((e) => e.kind === kind);
  if (res.length === 0) return;
  return res[0].config;
};

/**
 *
 * @param ownerName
 */
const getAllPreferences = async (ownerName: string): Promise<any> => {
  const table = await getPreferenceTable();
  return await table.getByTime(ownerName);
};

/**
 *
 * @param ownerName
 * @param kinds
 */
const delEntries = async (ownerName: string, kinds: string[]) => {
  const table = await getPreferenceTable();
  await table.bulkRemove(kinds.map((k) => ({ ownerName, kind: k })));
};

export { getAllPreferences, putPreference, getPreference, delEntries };
